import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var COLORS = {
  IN_STOCK: 'green',
  UNAVAILABLE: 'red',
  SOON: 'orange',
  MONTH: 'orange',
  WEEK: 'orange',
  LIMITED: 'orange',
  STORE_ONLY: 'black',
  DELETE: 'white',
  default: 'black'
};
export default {
  name: 'ProductStock',
  props: {
    stock: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showOnlyInStock: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentStock: function currentStock() {
      return this.stock.message || "".concat(this.$t('IN_STOCK'));
    },
    color: function color() {
      return COLORS[this.stock.status] || COLORS.default;
    }
  }
};